import React from 'react'
import {Panel, Input} from './index'
import useTranslation from '../../translation/hook'

export default function UICardText({state, methods, ...props}){
    const {setCardText} = methods
        
    const t = useTranslation ()

    function handleInputChange(e){
        setCardText(e.target.value)
    }
    
    
    
    return (
        <Panel title="">
            <Input placeholder={t("site_pages_shop_app_text_input")} onChange={handleInputChange} value={state.cardText}/>
        </Panel>
        
    )
}
